export default "<div class=\"auctioncast-video-container\" style=\"display:none;\"></div>"